import { Discont, DiscontStatus } from "@project/shared-types";
import { useState } from "react";
import { Switcher } from "../../../../components/Switcher/Switcher";
import { Text } from "../../../../components/texts/text";
import { _colorText, _sizeText } from "../../../../core/core";
import "./DiscontCard.css";
interface IDiscontCard {
    discont: Discont;
    onChangeActive: (enabled: boolean) => void;
}

export const DiscontCard = ({
    discont,
    onChangeActive
}: IDiscontCard) => {
    const [isActive, setIsActive] = useState(discont.status === DiscontStatus.OK);

    const handleChangeActive = (enabled: boolean) => {
        setIsActive(enabled);
        onChangeActive(enabled);
    }

    return (
        <div className="view-discont-card">
            <div className="view-discont-card__body">
                <Text size={_sizeText.xsbold} >Скидка {discont.percent}% от {discont.start_sum} ₽</Text>
                <Text size={_sizeText.xs} color={_colorText.neutral}>до {new Date(discont.date_close).toLocaleDateString()}</Text>
            </div>
            <Switcher checked={isActive} onChange={handleChangeActive} />
        </div>
    )
};